module.exports = __webpack_public_path__ + "static/media/gammaf.6b67c6cb.png";